__turbopack_context__.v({
  "className": "source_serif_4_f82c8d0a-module__Gukyyq__className",
  "variable": "source_serif_4_f82c8d0a-module__Gukyyq__variable",
});
